import 'bootstrap/dist/css/bootstrap.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client'

import { Provider } from 'react-redux';
//this prob is important but was blowing up AB
//import { ConnectedRouter } from 'connected-react-router';
import App from './App';
import registerServiceWorker from './registerServiceWorker';


// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
//const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const root = createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    /*<React.StrictMode>*/
            <App />
    /*</React.StrictMode>*/
);

registerServiceWorker();
